import React from "react";
import { Container, Row } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import giveaway from "../images/Gentle care.png";
const Giveaway = () => {
  return (
    <div>
      <Container>
        <Row>
          <h1 className="text-center ">Coming Soon....</h1>
        </Row>
        <Row>
          <Image src={giveaway} fluid />;
        </Row>
      </Container>
    </div>
  );
};

export default Giveaway;
